import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	AppTabs,
	Edit,
	Create,
	Crud,
	trans
} from '@/router/index'

import Agent from '@/components/modules/agents/Agent'
import Commissions from '@/components/modules/agents/Commissions'
import AgentTabs from '@/components/modules/agents/AgentTabs'
import AgentAnalytics from '@/components/modules/agents/AgentAnalytics'
import AgentsSettings from '@/components/modules/agents/settings/AgentsSettings'

export const agents = [
	{
		path: '/agents', 
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/agents/',
					text: 'Agenti',
				},
				{
					to: '/agents/commissions',
					text: 'Commissioni',
				},
			],
		},
		children: [
			{
				path: '/agents/',
				name: 'agents-index',
				meta: {
					title: trans('agents')
				},				
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'agent', next) },
				component: Crud,
				props: {
					modelDef: 'agents',
					actionIcon: 'recent_actors',
					title: 'Agenti',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/agents/commissions',
				meta: {
					title: trans('commissions')
				},				
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'agent', next) },
				component: Commissions,
			},
		],
	},
	{ 
		path: '/agents/create',
		name: 'agents-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'agents',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/agents/:id/edit',
		name: 'agents-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'agents',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/agents/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AgentTabs,
		props: (route) => ({
			id:  parseInt(route.params.id),
		}),
		children: [
			{
				path: '',
				name: 'agents-show', 
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'agent', next) },
				component: Agent,
				meta: {
					title: 'Agente'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
				}), 
			},
			{
				path: 'analytics',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'agent', next) },
				component: AgentAnalytics,
				meta: {
					title: 'Statistiche'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
				}),
			},
		]
	},
	{
		path: '/settingsagents/',
		name: 'settingsagents',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsagents',
					text: 'Agenti',
				},
			],
		},
		children: [
			{
				path: '/settingsagents/',
				beforeEnter: ifAuthenticatedOnline,
				component: AgentsSettings,
			},
		],
	},
]